import $ from "jquery";
import { App } from "../../App";
import { DeviceModel } from "../../Models/DeviceModel";

import "./Beprotect.less";

export class ServiceBeProtect {
    constructor() {
        new App();

        this.bindEvents();

        $(".smb-service-be-protect").toggleClass("smb-hide", false);
    }

    private bindEvents(): void {
        $(".smb-service-be-protect .smb-content-check .smb-check-button").on("click",
            (event: JQuery.TriggeredEvent): void => {
                const checkContainer: JQuery<Element> = $(event.currentTarget).closest(".smb-check-container");
                const currentValue: string = checkContainer.find(".smb-check-input").val() as string;

                if (!currentValue) {
                    checkContainer.toggleClass("smb-result-good", false);
                    checkContainer.toggleClass("smb-result-middle", false);
                    checkContainer.toggleClass("smb-result-bad", false);
                    checkContainer.toggleClass("smb-no-result", true);
                    checkContainer.find(".smb-check-info").text("Keine Seriennummer eingegeben");

                    return;
                }

                this.checkSerialnumber(currentValue).then(
                    (data: any, textStatus: string, jqXhr: JQueryXHR) => {
                        let deviceModel: DeviceModel;

                        switch (data.s) {
                            case "not_stolen":
                                deviceModel = this.createDeviceModel(data);
                                this.showCheckSerialNumberResult(checkContainer, true, false, false, deviceModel);
                                break;
                            case "stolen":
                                deviceModel = this.createDeviceModel(data);
                                this.showCheckSerialNumberResult(checkContainer, false, false, true, deviceModel);
                                break;
                            case "unknown":
                                this.showCheckSerialNumberResult(checkContainer, false, true, false);
                                break;
                        }
                    },
                    (jqXhr: JQueryXHR, textStatus: string, error: string) => {
                        console.error("getBlogEntry error");
                        console.error("--------------------------------------------------");
                        console.error("jqXhr: ", jqXhr);
                        console.error("textStatus: ", textStatus);
                        console.error("error: ", error);
                        console.error("--------------------------------------------------");
                    },
                );
            });

        $(".smb-service-be-protect .smb-content-head .smb-scroll-button").on("click",
            (event: JQuery.TriggeredEvent): void => {
                $(".smb-service-be-protect .smb-content").animate({
                    scrollTop: $(`.smb-service-be-protect .smb-content .smb-content-check`).offset()?.top,
                }, 600);
            });
    }

    private checkSerialnumber(serialNumber: string): JQueryXHR {
        const url: string = `https://api.sendmeback.de/api/device/stolen/${serialNumber}`;

        return $.ajax({
            dataType: "json",
            method: "GET",
            url,
        });
    }

    private createDeviceModel(data: any): DeviceModel {
        return {
            manufacturer: data.back.model[0].manufacturer.name,
            name: data.back.model[0].name,
        };
    }

    private showCheckSerialNumberResult(
        checkContainer: JQuery<Element>,
        isgood: boolean,
        isMiddle: boolean,
        isBad: boolean,
        deviceModel?: DeviceModel,
    ) {
        checkContainer.toggleClass("smb-result-good", isgood);
        checkContainer.toggleClass("smb-result-middle", isMiddle);
        checkContainer.toggleClass("smb-result-bad", isBad);
        checkContainer.toggleClass("smb-no-result", false);

        let resultText: string = "";
        let infoText: string = "";
        let deviceText: string = "";

        if (isgood) {
            resultText = "GLÜCKWUNSCH!";
            infoText = "Gegenstand ist nicht gesperrt.";
            deviceText = `Info: ${deviceModel?.name} (${deviceModel?.manufacturer})`;
        }

        if (isMiddle) {
            resultText = "INFO!";
            infoText = "Gegenstand ist im System nicht hinterlegt.";
            deviceText = "";
        }

        if (isBad) {
            resultText = "ACHTUNG!";
            infoText = "Gegenstand ist gesperrt.";
            deviceText = `Info: ${deviceModel?.name} (${deviceModel?.manufacturer})`;
        }

        checkContainer.find(".smb-check-result").html(resultText);
        checkContainer.find(".smb-check-info").text(infoText);
        checkContainer.find(".smb-check-device").text(deviceText);
    }
}

$((): void => {
    if ($(".smb-service-be-protect").length > 0) {
        new ServiceBeProtect();
    }
});